/* ==========================================================================
   [#10] Prefer the "Large" size on product load.
   Kalles renders size options as <li class="nt-swatch" data-value="...">
   backed by a hidden <select name="id">. Clicking the option drives the
   theme's own variant pipeline, so the real variant id, the displayed price
   and the Add to cart payload all update through the normal path.

   The theme binds its swatch handlers after DOMContentLoaded, so the click
   is retried until it actually registers (li gains .is-selected), then stops.
   Skipped when the URL already names a variant, and skipped if the shopper
   has already chosen an option.
   ========================================================================== */
(function () {
  'use strict';

  var MAX_ATTEMPTS = 24;   // ~5s ceiling
  var STEP = 200;

  function findLarge(form) {
    var lis = form.querySelectorAll('li.nt-swatch, li.swatch_pr_item');
    for (var i = 0; i < lis.length; i++) {
      var v = (lis[i].getAttribute('data-value') || '') + ' ' + (lis[i].getAttribute('data-escape') || '');
      if (/large/i.test(v)) return lis[i];
    }
    var radios = form.querySelectorAll('input[type="radio"]');
    for (var j = 0; j < radios.length; j++) {
      if (/large/i.test(radios[j].value || '')) return radios[j];
    }
    return null;
  }

  function done(form) { if (form) form.dataset.hlLargeDone = '1'; }

  function preferLarge(attempt) {
    attempt = attempt || 0;
    if (attempt > MAX_ATTEMPTS) return;
    if (/[?&]variant=/.test(window.location.search)) return;

    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return setTimeout(function () { preferLarge(attempt + 1); }, STEP);
    if (form.dataset.hlLargeDone === '1') return;

    var target = findLarge(form);
    if (!target) return setTimeout(function () { preferLarge(attempt + 1); }, STEP);

    // Already on Large, or the shopper picked something themselves: leave it alone.
    if (target.classList.contains('is-selected') || target.checked) return done(form);
    if (form.querySelector('li.nt-swatch.is-selected, li.swatch_pr_item.is-selected')) return done(form);

    target.click();

    setTimeout(function () {
      if (target.classList.contains('is-selected') || target.checked) { done(form); }
      else { preferLarge(attempt + 1); }
    }, STEP);
  }

  function boot() { preferLarge(0); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
